import { IProcedure } from 'constants/types';

const setProceduresInput: (
  procedures: IProcedure[],
) => IProceduresInput | Object = (procedures) =>
  procedures != null && procedures.length > 0
    ? {
        procedures: procedures.map((p: any) => ({
          label: p.label,
          timestamp: p.timestamp,
          id: p.id,
        })),
      }
    : { procedures: [] };

export { setProceduresInput };

interface IProceduresInput {
  procedures: Array<{
    id: string;
    label: string;
    timestamp: Date;
  }>;
}
